class navHelper {

    constructor() {}

    listenForScroll(el) {
        if (!el.classList.contains('no-hero')) {
            document.addEventListener('scroll', () => {
                if (document.body.getBoundingClientRect().top < 0) {
                    el.classList.add('is-opaque');
                } else {
                    el.classList.remove('is-opaque');
                }
            }, {passive: true});
        }
    }
}

window.app.add('nav', new navHelper());